import { useQuery } from '@tanstack/react-query';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getBotAllowedUsers: botTypes.GetAllowedUsers = () => {
  return axios.get('/bot/allowed-users');
};

type QueryFnType = typeof getBotAllowedUsers;

type UseGetBotAllowedUsersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetBotAllowedUsers = ({ config = {} }: UseGetBotAllowedUsersOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['bot-allowed-users'],
    queryFn: getBotAllowedUsers,
  });
};
